// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import HoverMRRDescription from './HoverMRRDescription'
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

function EINIntegrationProductRow() {
   const state = useQuoteContext()
   const { getString } = state
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (state.einIntegrationsCount === 0) {
      return <></>
   }

   const { productEECount, totalPrice } = state.productEINIntegrationsTotalCosts
   const perIntegrationPrice =
      productEECount > 0 ? totalPrice / productEECount : null

   return (
      <div className='row'>
         <div className='col-bhr1'>
            {getString('product.EINIntegrationProductRow.ProductName')}
         </div>
         <div className='col-bhr2'>
            <input
               className='form-control'
               type='number'
               value={productEECount}
               disabled
            />
         </div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'>
            {perIntegrationPrice != null
               ? formatFloatAsCurrencySymbol(
                    perIntegrationPrice,
                    state.currencyObjectUSD,
                 )
               : ''}
         </div>
         <div className='col'>
            {formatFloatAsCurrencySymbol(totalPrice, state.currencyObjectUSD)}
         </div>
         {state.differenceQuote == true ? (
            <>
               <div className='col'>
                  {formatFloatAsCurrencySymbol(
                     state.productEINIntegrationsTotalCosts.previousTotalPrice,
                     state.currencyObjectUSD,
                  )}
               </div>
               {ShowMRROnDifferenceQuotes ? (
                  <HoverMRRDescription
                     listMRRTotal={
                        state.productEINIntegrationsTotalCosts.listMRRTotal
                     }
                     previousMRRTotal={
                        state.productEINIntegrationsTotalCosts.previousMRRTotal
                     }
                     MRRTotal={state.productEINIntegrationsTotalCosts.MRRTotal}
                     MRRTotalUSD={
                        state.productEINIntegrationsTotalCosts.MRRTotalUSD
                     }
                     currencyObjectCurrent={state.currencyObject}
                     currencyObjectUSD={state.currencyObjectUSD}
                  >
                     <span className='hoverable'>
                        {formatFloatAsCurrencySymbol(
                           state.productEINIntegrationsTotalCosts
                              .totalPriceDifference,
                           state.currencyObjectUSD,
                        )}
                     </span>
                  </HoverMRRDescription>
               ) : (
                  <span className='col'>
                     {formatFloatAsCurrencySymbol(
                        state.productEINIntegrationsTotalCosts
                           .totalPriceDifference,
                        state.currencyObjectUSD,
                     )}
                  </span>
               )}
            </>
         ) : (
            <></>
         )}
      </div>
   )
}

export default EINIntegrationProductRow
